interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

const UserProfileIcon = ({ width = 19, height = 19, color = '#745BE3' }: Properties) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 19 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.16667 0C2.74167 0 0 2.74167 0 9.16667C0 15.5917 2.74167 18.3333 9.16667 18.3333C15.5917 18.3333 18.3333 15.5917 18.3333 9.16667C18.3333 2.74167 15.5917 0 9.16667 0ZM5.58917 16.2292C5.90333 14.9425 6.73083 14.1667 9.16667 14.1667C11.6025 14.1667 12.4308 14.9425 12.7442 16.2292C11.7642 16.5267 10.5825 16.6667 9.16667 16.6667C7.75083 16.6667 6.56917 16.5267 5.58917 16.2292ZM14.2667 15.525C13.4233 12.8442 11.0033 12.4992 9.1675 12.4992C7.33167 12.4992 4.91167 12.8433 4.06833 15.525C2.37833 14.4 1.6675 12.38 1.6675 9.16583C1.66667 3.69917 3.69917 1.66667 9.16667 1.66667C14.6342 1.66667 16.6667 3.69917 16.6667 9.16667C16.6667 12.3808 15.9558 14.4008 14.2658 15.5258L14.2667 15.525ZM9.16667 4.16667C6.92417 4.16667 5.83333 5.2575 5.83333 7.5C5.83333 9.7425 6.92417 10.8333 9.16667 10.8333C11.4092 10.8333 12.5 9.7425 12.5 7.5C12.5 5.2575 11.4092 4.16667 9.16667 4.16667ZM9.16667 9.16667C7.8425 9.16667 7.5 8.82417 7.5 7.5C7.5 6.17583 7.8425 5.83333 9.16667 5.83333C10.4908 5.83333 10.8333 6.17583 10.8333 7.5C10.8333 8.82417 10.4908 9.16667 9.16667 9.16667Z'
        fill={color}
      />
    </svg>
  );
};

export default UserProfileIcon;
